/* eslint-disable max-len */
import React from 'react'
import { Row, Col, Tab } from 'react-bootstrap'
import {
  GridComponent,
  ColumnsDirective,
  ColumnDirective,
} from '@syncfusion/ej2-react-grids'

type PatientStatsProps = {
  patient: {
    created_date: string
    future_visit: string
  }
}

const PatientStats: React.FC<PatientStatsProps> = ({ patient }) => {
  return (
    <Tab.Pane eventKey="third">
      {/* Upper Section */}
      <Row className="p-2">
        <Col md="6">
          <div className="mb-stats-box position-relative text-center pt-1 h-100">
            <div className="mb-stats-icon d-inline-block bg-blue rounded-pill p-2 text-white position-relative">
              <i className="bi bi-calendar-event"></i>
            </div>
            <div className="bb-stats border border-2 rounded text-center p-2 position-relative">
              <div className="mt-3">Last visit</div>
              <div className="fw-bold">{patient.created_date}</div>
              <div>Type: Hygiene</div>
            </div>
          </div>
        </Col>
        <Col md="6">
          <div className="mb-stats-box position-relative text-center pt-1 h-100">
            <div className="mb-stats-icon d-inline-block bg-green rounded-pill p-2 text-white position-relative">
              <i className="bi bi-calendar-event"></i>
            </div>
            <div className="bb-stats border border-2 rounded text-center p-2 position-relative">
              <div className="mt-3">Next visit</div>
              <div className="fw-bold">{patient.future_visit}</div>
              <div>Type: Restorative</div>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col className="mx-2">
          <GridComponent
            dataSource={[
              {
                Hierarchy: 'H1',
                Carrier: 'Carr1',
                Plan: 'Plan1',
                GroupNumber: '111',
                RemIndMax: '$1,000',
                Status: 'Active',
              },
            ]}
            allowPaging={true}
          >
            <ColumnsDirective>
              <ColumnDirective field="Hierarchy" headerText="Hierarchy" />
              <ColumnDirective field="Carrier" headerText="Carrier" />
              <ColumnDirective field="Plan" headerText="Plan" />
              <ColumnDirective field="GroupNumber" headerText="Group #" />
              <ColumnDirective field="RemIndMax" headerText="Rem. Ind. Max" />
              <ColumnDirective field="Status" headerText="Status" />
            </ColumnsDirective>
          </GridComponent>
        </Col>
      </Row>
      <Row>
        <Col className="mx-2">
          <GridComponent
            dataSource={[
              { Code: 'D111', Pat: '$0', Ins: '$0', Total: '$0' },
              { Code: 'D111', Pat: '$0', Ins: '$0', Total: '$0' },
            ]}
            allowPaging={true}
          >
            <ColumnsDirective>
              <ColumnDirective field="Code" headerText="Codes" />
              <ColumnDirective field="Pat" headerText="Pat." />
              <ColumnDirective field="Ins" headerText="Ins." />
              <ColumnDirective field="Total" headerText="Total" />
            </ColumnsDirective>
          </GridComponent>
        </Col>
      </Row>
    </Tab.Pane>
  )
}

export default PatientStats
